import {Button, Modal} from "antd";
import React, {useContext, useState} from "react";
import {FormattedMessage} from "react-intl";
import '../assets/css/Dentobook.css';
import {MedicalStaff} from "../api-client";
import MedicalStaffDetailsView from "../components/medicalStaff/MedicalStaffDetailsView";
import {CloseOutlined} from "@ant-design/icons";
import {ExitPromptContext} from "../context/ExitPromptContext";
import {DentobookApplicationContext} from "../context/DentobookApplicationContext";
import {getMedicalStaffFormComponent} from "../utils/medicalUtils";

interface MedicalStaffDetailsProps {
    medicalStaff: MedicalStaff;
    setMedicalStaff: Function;
    editMode: boolean;
    setEditMode: Function;
}

const MedicalStaffDetails = ({medicalStaff, setMedicalStaff, editMode, setEditMode}: MedicalStaffDetailsProps) => {

    const {setFormDirty} = useContext(ExitPromptContext);

    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

    const { userOrganization } = React.useContext(DentobookApplicationContext);

    const FormComponent = getMedicalStaffFormComponent(userOrganization);

    const initialMedicalStaff = {...medicalStaff};

    const handleOk = () => {
        setFormDirty(false);
        setIsModalOpen(false);
        setMedicalStaff(initialMedicalStaff);
        setEditMode(false);
    };

    const handleCancel = () => {
        setIsModalOpen(false);
    };

    if (!medicalStaff.id) {
        return null;
    }

    const footer = <div className="modal-btn-wrapper">
        <Button className="modal-btn" onClick={handleCancel}>
            {<FormattedMessage id="cancel"/>}
        </Button>
        <Button className="modal-btn" type="primary" onClick={handleOk}
        >
            {<FormattedMessage id="confirm"/>}
        </Button>
    </div>

    return (
        <>
            <Modal
                transitionName=""
                className="dentobook-modal"
                okButtonProps={{
                    className: "modal-btn"
                }}
                cancelButtonProps={{
                    className: "modal-btn"
                }}
                title={<FormattedMessage id="update_medical_staff"/>}
                closeIcon={<CloseOutlined className={'icon-24px'} onClick={handleCancel}/>}
                footer={footer}
                open={isModalOpen} onOk={handleOk} onCancel={handleCancel}>
                <h3 className="dentobook-content font-weight-500 font-24 text-align-center"><FormattedMessage
                    id="unsaved_changes"/></h3>
            </Modal>
            {
                editMode ?
                    <FormComponent
                        setEditMode={setEditMode}
                        openModal={() => setIsModalOpen(true)}
                        medicalStaff={medicalStaff}
                        setMedicalStaff={setMedicalStaff}
                        mode={1}
                    />
                    :
                    <MedicalStaffDetailsView medicalStaff={medicalStaff} setEditMode={setEditMode} setMedicalStaff={setMedicalStaff as (staff: MedicalStaff) => void}/>
            }
        </>
    );
};

export default MedicalStaffDetails;